// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pu-c";
export var backButton = "_pu-4";
export var backIcon = "_pu-5";
export var chevronShortcut = "_pu-6";
export var container = "_pu-1";
export var editor = "_pu-8";
export var editorWrapper = "_pu-7";
export var prefix = "_pu-2";
export var searchIcon = "_pu-3";
export var suffix = "_pu-9";
export var suffixContent = "_pu-a";
export var suffixText = "_pu-b";
export var wrapper = "_pu-0";